export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readCount: number;
  commentCount: number;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-001',
    title: '独家爆料：某顶流男星深夜私会神秘女子，酒店同住三天三夜',
    slug: 'exclusive-top-star-secret-date',
    excerpt: '据知情人士透露，某当红顶流男星近日被拍到与一名神秘女子深夜进入某五星级酒店，两人在酒店内共度三天三夜未出房门。该男星此前一直以单身形象示人，此次被拍引发粉丝强烈反应。',
    content: `<p>据知情人士透露，某当红顶流男星近日被拍到与一名神秘女子深夜进入某五星级酒店，两人在酒店内共度三天三夜未出房门。</p>
<p>据悉，该男星近期正在横店拍摄一部古装剧，但趁剧组休息期间悄悄返回北京。狗仔队在酒店外蹲守三天，拍到多次外卖送入房间的画面，却始终未见两人外出。</p>
<p>该男星此前一直以单身形象示人，经纪团队也多次对外强调其专注于事业。此次被拍事件引发粉丝强烈反应，微博超话瞬间炸锅。</p>
<p>更令人震惊的是，有眼尖网友扒出该神秘女子疑似某知名导演的前妻，两人若真的在一起，恐怕将在圈内掀起轩然大波。</p>
<p>截至发稿前，该男星工作室尚未对此事作出任何回应。本社将持续关注此事进展。</p>
<h2>粉丝反应两极分化</h2>
<p>消息传出后，粉丝群体迅速分裂为两派。一派认为偶像也是正常人，有权拥有私人感情生活；另一派则愤怒表示被欺骗，要求工作室给出解释。</p>
<p>有粉丝在超话发帖称："我们不是反对他谈恋爱，而是讨厌被欺骗。既然有女朋友，为什么要一直卖单身人设？"</p>
<h2>圈内人士爆料更多细节</h2>
<p>一位不愿透露姓名的圈内人士向本社爆料，该男星与这位女子其实已经秘密交往超过半年，只是保密工作做得极好。两人通过共同朋友介绍认识，女方家境优渥，在圈内人脉广泛。</p>`,
    category: 'mingxing-heiliao',
    categoryName: '明星黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20silhouette%20of%20a%20male%20celebrity%20entering%20a%20luxury%20hotel%20at%20night%20with%20paparazzi%20camera%20flash%20in%20the%20foreground%2C%20cinematic%20lighting%2C%20dark%20moody%20atmosphere%2C%20film%20noir%20style%2C%20dramatic%20shadows%2C%20photorealistic&width=800&height=450&seq=article-001&orientation=landscape',
    author: '黑料社调查组',
    publishDate: '2026-08-06',
    readCount: 285600,
    commentCount: 4823,
    tags: ['顶流男星', '私会', '酒店', '恋情曝光', '单身人设'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-002',
    title: '某女星综艺后台耍大牌，对工作人员爆粗口全程被录音',
    slug: 'actress-diva-behavior-recording',
    excerpt: '一段长达八分钟的录音今日在网上疯传，录音中某知名女星在综艺节目后台对工作人员大声呵斥、爆粗口，态度极其恶劣。该录音已被确认真实，引发网友集体抵制。',
    content: `<p>一段长达八分钟的录音今日在各大社交平台疯传。录音中，某知名女星在综艺节目后台对工作人员大声呵斥、爆粗口，态度极其恶劣。</p>
<p>录音中可以清晰听到该女星因为化妆师迟到了五分钟而大发雷霆，用极其难听的语言辱骂对方。当现场工作人员试图调解时，该女星更是将怒火转向了所有人。</p>
<p>"你知道我是谁吗？你知道我的时间有多宝贵吗？你们这群废物，连最基本的准时都做不到！"录音中该女星的言辞令人震惊。</p>
<p>据悉，该录音已经过多方确认真实。涉事综艺节目的多名工作人员也纷纷在社交媒体上发文证实此事。</p>
<h2>品牌方紧急解约</h2>
<p>事件发酵后，该女星代言的三个品牌已在两小时内宣布解约。品牌方在声明中表示："我们坚决反对任何形式的不尊重行为。"</p>
<p>业内人士分析，此次事件对该女星的事业将造成毁灭性打击，预计损失可能超过五千万。</p>`,
    category: 'zongyi-jiemu',
    categoryName: '综艺节目',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20backstage%20area%20of%20a%20TV%20studio%20with%20dramatic%20lighting%2C%20silhouette%20of%20an%20angry%20person%20shouting%20at%20staff%2C%20tense%20atmosphere%2C%20cinematic%20photography%2C%20moody%20shadows&width=800&height=450&seq=article-002&orientation=landscape',
    author: '黑料社编辑部',
    publishDate: '2026-08-05',
    readCount: 192400,
    commentCount: 3651,
    tags: ['女星', '耍大牌', '综艺', '录音', '品牌解约'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-003',
    title: '网红主播偷税漏税被查，补缴金额高达两千万',
    slug: 'influencer-tax-evasion',
    excerpt: '国家税务总局今日公布一起网络主播偷税漏税案，某知名带货主播通过设立空壳公司、虚假申报等手段偷逃税款，已被追缴税款并处罚款共计两千余万元。',
    content: `<p>国家税务总局今日公布一起重大网络主播偷税漏税案件。某拥有三千万粉丝的知名带货主播，通过设立空壳公司、虚假申报等手段偷逃税款，已被追缴税款并处罚款共计两千余万元。</p>
<p>据通报，该主播在2024至2026年期间，通过多个空壳公司将直播带货收入进行拆分，将本应按劳务报酬缴纳高额个税的收入转化为企业经营所得，严重违反了税收法律法规。</p>
<p>税务部门通过大数据分析发现异常后，对该主播进行了深入调查，最终查实其偷逃税款的行为。</p>
<h2>直播账号已被封禁</h2>
<p>目前该主播在各大平台的直播账号均已被封禁。其所属的MCN机构也紧急发布声明，表示将配合相关部门调查，并与该主播解除合作关系。</p>
<p>这已经是今年第三起知名网红偷税漏税被查的案件，网友纷纷感叹："赚那么多钱还偷税，活该！"</p>`,
    category: 'wanghong-bagua',
    categoryName: '网红爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20office%20with%20financial%20documents%20spread%20on%20a%20desk%2C%20a%20calculator%20and%20stacks%20of%20money%20in%20the%20background%2C%20dark%20moody%20atmosphere%2C%20investigative%20journalism%20aesthetic%2C%20dramatic%20lighting&width=800&height=450&seq=article-003&orientation=landscape',
    author: '黑料社财经组',
    publishDate: '2026-08-04',
    readCount: 167800,
    commentCount: 2890,
    tags: ['网红', '偷税漏税', '直播带货', '封禁'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-004',
    title: '某选秀节目黑幕曝光：冠军早已内定，选手被迫签霸王条款',
    slug: 'talent-show-fixed-winner',
    excerpt: '一位参加某热门选秀节目的选手向本社独家爆料，该节目存在严重黑幕。冠军人选在节目开播前就已内定，所有选手被迫签署十年长约的霸王条款。',
    content: `<p>一位参加某热门选秀节目的选手向本社独家爆料，揭露该节目存在严重黑幕。</p>
<p>据该选手透露，节目冠军人选在正式录制前就已内定。所谓的观众投票、评委打分全部都是走过场，最终结果早已确定。</p>
<p>"我们在签约的时候就被要求签署一份十年长约，如果不签就不能参加节目。合同里规定十年内所有商业活动的收入三七分成，公司拿七成。"该选手愤怒地表示。</p>
<p>更令人震惊的是，合同中还有一条"如果不服从公司安排，需要支付五千万违约金"的条款。这意味着一旦签约，选手们实际上成为了公司的"奴隶"。</p>
<h2>多位选手集体发声</h2>
<p>在本社报道后，多位参加该节目的选手纷纷在社交媒体上发声，证实了这些黑幕的存在。有选手晒出了合同的部分截图，引发轩然大波。</p>
<p>目前，该节目制作方尚未对此事作出回应。</p>`,
    category: 'yulequan-neimu',
    categoryName: '娱乐圈内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20stage%20with%20spotlight%20and%20a%20broken%20trophy%20on%20the%20floor%2C%20behind%20the%20scenes%20of%20a%20talent%20show%2C%20dramatic%20moody%20lighting%2C%20tense%20atmosphere%2C%20cinematic%20photography&width=800&height=450&seq=article-004&orientation=landscape',
    author: '黑料社调查组',
    publishDate: '2026-08-03',
    readCount: 145200,
    commentCount: 3120,
    tags: ['选秀', '黑幕', '霸王条款', '内定冠军'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-005',
    title: '某知名导演被多名女演员联名举报性骚扰，证据令人发指',
    slug: 'director-sexual-harassment',
    excerpt: '五位女演员今日联合发布声明，实名举报某知名导演在拍摄期间对她们进行性骚扰。举报材料中包含大量聊天记录和录音证据，内容令人触目惊心。',
    content: `<p>五位女演员今日联合发布声明，实名举报某知名导演在拍摄期间对她们进行性骚扰。</p>
<p>举报材料中包含大量微信聊天记录和录音证据。聊天记录显示，该导演多次深夜以"讨论剧本"为由约女演员单独见面，言语中充满性暗示和威胁。</p>
<p>一位举报人在声明中写道："他告诉我，如果我不配合他，我在这个圈子就永远别想出头。很多角色机会都会和我无缘。"</p>
<p>另一位举报人提供的录音中，可以清晰听到该导演说："你跟了我，这部戏的女二号就是你的。圈子里都是这样的，你装什么清高？"</p>
<h2>影视行业协会紧急介入</h2>
<p>事件曝光后，中国电影家协会、中国电视剧制作产业协会等多家行业协会紧急发布声明，表示将严肃调查此事，坚决维护行业风气。</p>
<p>截至目前，该导演的所有正在进行的项目均已被暂停。</p>`,
    category: 'yingshi-dongtai',
    categoryName: '影视动态',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20empty%20director%20chair%20on%20a%20film%20set%20with%20spotlight%2C%20shadowy%20atmosphere%2C%20tense%20and%20disturbing%20mood%2C%20cinematic%20lighting%2C%20film%20noir%20aesthetic&width=800&height=450&seq=article-005&orientation=landscape',
    author: '黑料社编辑部',
    publishDate: '2026-08-02',
    readCount: 213500,
    commentCount: 5021,
    tags: ['导演', '性骚扰', '女演员', '举报', '行业丑闻'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-006',
    title: '某歌手新歌被指抄袭海外作品，扒谱对比惊人相似',
    slug: 'singer-plagiarism-exposed',
    excerpt: '某当红歌手上周发布的新歌被网友发现与一首海外歌曲高度相似。音乐博主发布了两首歌的扒谱对比视频，旋律相似度高达90%，引发全民热议。',
    content: `<p>某当红歌手上周发布的新歌被网友发现与一首2025年发行的海外歌曲高度相似。</p>
<p>一位拥有百万粉丝的音乐博主发布了两首歌的扒谱对比视频，视频显示两首歌曲的主旋律几乎完全一致，相似度高达90%以上。</p>
<p>"这不是借鉴，这就是赤裸裸的抄袭。"该博主在视频中愤怒地表示。</p>
<p>更令人震惊的是，这位歌手此前就曾多次陷入抄袭争议。有网友整理了一份"抄袭合辑"，列出了该歌手近三年内七首疑似抄袭的歌曲。</p>
<h2>粉丝控评引发更大反弹</h2>
<p>事件发酵后，该歌手的粉丝迅速组织控评，在各大平台刷"只是巧合""旋律相似很正常"等言论。然而这种控评行为引发了更大的舆论反弹。</p>
<p>大量路人网友涌入评论区，批评粉丝"无脑护主"。该话题迅速登上微博热搜榜首。</p>`,
    category: 'yinyue-quan',
    categoryName: '音乐圈',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20music%20studio%20with%20sheet%20music%20on%20a%20stand%2C%20two%20identical%20music%20sheets%20side%20by%20side%20showing%20plagiarism%2C%20moody%20atmosphere%2C%20dramatic%20shadows%2C%20investigative%20tone&width=800&height=450&seq=article-006&orientation=landscape',
    author: '黑料社音乐组',
    publishDate: '2026-08-01',
    readCount: 134200,
    commentCount: 2845,
    tags: ['歌手', '抄袭', '新歌', '扒谱', '海外作品'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-007',
    title: '某知名经纪人卷款跑路，旗下艺人集体维权',
    slug: 'agent-absconded-with-money',
    excerpt: '娱乐圈再爆大瓜！某知名经纪人被爆卷走旗下五位艺人的演出费和代言费共计三千万元后失联。目前艺人已向警方报案，并联合发起民事诉讼。',
    content: `<p>娱乐圈再爆大瓜！某知名经纪人被爆卷走旗下五位艺人的演出费和代言费共计三千万元后失联。</p>
<p>据悉，该经纪人在圈内颇有声望，旗下管理着多位二三线艺人。然而上周他突然失联，电话关机、微信拉黑、办公室人去楼空。</p>
<p>"我们完全没想到他会做出这种事。"一位受害艺人哽咽地告诉记者，"我们合作了五年，一直把他当亲大哥一样信任。"</p>
<p>经查，该经纪人已将名下的房产和车辆全部变卖，疑似早已策划好跑路计划。</p>
<h2>警方已立案侦查</h2>
<p>目前，受害艺人已联合向警方报案。警方表示已立案侦查，正在全力追查该经纪人的下落。</p>
<p>此事件也引发了娱乐圈对经纪人行业监管的广泛讨论。多位业内人士呼吁建立经纪人行业准入制度和信用体系。</p>`,
    category: 'mingxing-heiliao',
    categoryName: '明星黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20empty%20office%20with%20scattered%20papers%20and%20an%20open%20safe%2C%20dark%20moody%20atmosphere%2C%20abandoned%20desk%2C%20dramatic%20lighting%2C%20crime%20scene%20aesthetic&width=800&height=450&seq=article-007&orientation=landscape',
    author: '黑料社调查组',
    publishDate: '2026-07-31',
    readCount: 98600,
    commentCount: 1856,
    tags: ['经纪人', '卷款跑路', '艺人维权', '报案'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-008',
    title: '某网红的豪宅派对曝光：一晚消费抵普通人十年工资',
    slug: 'influencer-luxury-party',
    excerpt: '一位参加过某知名网红私人派对的知情人士向本社爆料，该网红的生日派对奢华程度令人瞠目结舌，一晚消费高达五百万，其中包括大量名酒和奢侈品礼物。',
    content: `<p>一位参加过某知名网红私人派对的知情人士向本社爆料，该网红的生日派对奢华程度令人瞠目结舌。</p>
<p>据透露，这场在私人别墅举办的派对邀请了近百位宾客，现场布置堪比电影场景。光鲜花装饰一项就花费了三十万。</p>
<p>"桌上摆的都是路易十三和罗曼尼康帝，一瓶就要几万块。"知情人士描述道，"送的伴手礼是爱马仕的丝巾和香水，每人一份。"</p>
<p>派对的高潮是该网红当众宣布给每位到场的闺蜜送一只爱马仕铂金包，仅此项花费就超过两百万。</p>
<h2>网友热议：钱从哪来？</h2>
<p>消息传出后，网友纷纷质疑：一个网红的收入能支撑如此奢靡的消费？钱到底从哪来？</p>
<p>有人猜测其背后有金主支持，也有人怀疑其存在偷税漏税行为。目前该网红尚未对此事做出回应。</p>`,
    category: 'wanghong-bagua',
    categoryName: '网红爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20luxurious%20private%20villa%20party%20scene%20at%20night%20with%20champagne%20tower%20and%20designer%20gifts%2C%20dim%20warm%20lighting%2C%20extravagant%20lifestyle%2C%20dark%20moody%20atmosphere%2C%20cinematic%20photography&width=800&height=450&seq=article-008&orientation=landscape',
    author: '黑料社编辑部',
    publishDate: '2026-07-30',
    readCount: 112300,
    commentCount: 2340,
    tags: ['网红', '奢华派对', '高消费', '质疑'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-009',
    title: '娱乐圈资本局：某影视公司被曝洗钱，涉及多位明星艺人',
    slug: 'entertainment-money-laundering',
    excerpt: '某知名影视公司近日被监管部门调查，涉嫌通过影视投资项目进行洗钱活动。据悉，多位明星艺人的工作室与该公司存在密切资金往来，可能被卷入调查。',
    content: `<p>某知名影视公司近日被监管部门调查，涉嫌通过影视投资项目进行洗钱活动。</p>
<p>据接近调查的消息人士透露，该公司通过虚报影视制作成本、签订阴阳合同等方式，在三年内洗钱金额可能高达数十亿元。</p>
<p>"他们把一个实际成本只有两千万的项目，在账面上做成了两个亿。多出来的钱通过各种渠道转移出去。"一位知情人士解释道。</p>
<p>更引人关注的是，多位明星艺人的工作室与该公司存在密切资金往来。这些艺人可能被卷入调查，面临法律风险。</p>
<h2>行业或将迎来大洗牌</h2>
<p>分析人士认为，此次调查可能只是冰山一角。娱乐圈资本运作长期缺乏有效监管，乱象丛生。</p>
<p>"如果真的深挖下去，恐怕半个娱乐圈都要地震。"一位不愿透露姓名的行业分析师表示。</p>`,
    category: 'yulequan-neimu',
    categoryName: '娱乐圈内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20corporate%20office%20with%20financial%20charts%20and%20documents%20being%20shredded%2C%20shadowy%20figures%20in%20the%20background%2C%20white%20collar%20crime%20aesthetic%2C%20dramatic%20lighting%2C%20tense%20atmosphere&width=800&height=450&seq=article-009&orientation=landscape',
    author: '黑料社财经组',
    publishDate: '2026-07-29',
    readCount: 89200,
    commentCount: 1650,
    tags: ['资本', '洗钱', '影视公司', '明星', '调查'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-010',
    title: '某综艺常驻嘉宾被曝学历造假，真实学历仅初中毕业',
    slug: 'variety-guest-fake-degree',
    excerpt: '一位自称是某综艺节目常驻嘉宾老同学的网友今日发帖爆料，该嘉宾在节目中声称的"某知名大学硕士"学历纯属造假，其真实学历仅为初中毕业。',
    content: `<p>一位自称是某综艺节目常驻嘉宾老同学的网友今日发帖爆料，该嘉宾学历存在严重造假。</p>
<p>帖子中称，该嘉宾在节目中多次声称自己是某知名大学的硕士研究生，但实际上他只读完了初中就辍学了。帖主还附上了当年的初中毕业照作为证据。</p>
<p>"我跟他是一个镇上的，初中同班同学。他初中毕业后就去打工了，根本就没上过大学。"帖主在帖子中写道。</p>
<p>随后有网友通过学信网查询，发现该知名大学的研究生名单中确实没有该嘉宾的名字。</p>
<h2>节目组紧急回应</h2>
<p>事件发酵后，该综艺节目组紧急发布声明，表示正在核实嘉宾信息，如果造假属实将立即取消其嘉宾资格。</p>
<p>该嘉宾目前尚未做出任何回应，但其社交媒体账号的评论区已经彻底沦陷。</p>`,
    category: 'zongyi-jiemu',
    categoryName: '综艺节目',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20classroom%20with%20a%20diploma%20hanging%20crookedly%20on%20the%20wall%2C%20moody%20atmosphere%2C%20shadows%20and%20dramatic%20lighting%2C%20investigative%20tone%2C%20cinematic%20photography&width=800&height=450&seq=article-010&orientation=landscape',
    author: '黑料社编辑部',
    publishDate: '2026-07-28',
    readCount: 105600,
    commentCount: 2190,
    tags: ['综艺', '学历造假', '嘉宾', '人设崩塌'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-011',
    title: '某女星婚内出轨实锤！与男模酒店幽会被拍正面照',
    slug: 'actress-affair-evidence',
    excerpt: '狗仔队今日曝光一组照片，某已婚女星与一名男模在某酒店大堂拥抱接吻，画面清晰无误。该女星丈夫是圈内知名制片人，两人结婚仅三年。',
    content: `<p>狗仔队今日曝光一组令人震惊的照片，某已婚女星与一名年轻男模在某酒店大堂公开拥抱接吻，画面清晰不容辩解。</p>
<p>照片显示，两人在大堂等候电梯时举止亲密，旁若无人地拥抱和亲吻。随后两人一同进入电梯前往客房楼层，直到第二天中午才先后离开。</p>
<p>该女星的丈夫是圈内知名制片人，两人在圈内一直以恩爱夫妻形象示人，结婚仅三年，育有一子。</p>
<h2>男方身份被扒出</h2>
<p>网友迅速扒出照片中男模的身份。该男模今年25岁，是一名小有名气的平面模特，社交账号上有数十万粉丝。</p>
<p>有网友发现，该男模与女星在多个活动中同框出现，两人的社交媒体也曾多次互相点赞。出轨一事似乎早有端倪。</p>
<p>截至目前，双方均未对此事做出回应。但女星的丈夫已悄悄清空了社交媒体上所有与妻子的合照。</p>`,
    category: 'mingxing-heiliao',
    categoryName: '明星黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20hotel%20lobby%20at%20night%20with%20two%20shadowy%20figures%20embracing%2C%20paparazzi%20camera%20angle%2C%20moody%20atmosphere%2C%20dramatic%20lighting%2C%20scandal%20theme%2C%20cinematic%20photography&width=800&height=450&seq=article-011&orientation=landscape',
    author: '黑料社狗仔队',
    publishDate: '2026-07-27',
    readCount: 324100,
    commentCount: 7820,
    tags: ['女星', '婚内出轨', '男模', '实锤', '正面照'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-012',
    title: '某知名导演新片票房惨败，被曝拍摄期间多次改剧本导致超支',
    slug: 'director-box-office-flop',
    excerpt: '某知名导演筹备三年的新片上映首周票房惨不忍睹，仅收获三千万。据剧组人员爆料，该导演在拍摄期间反复修改剧本，导致制作成本从八千万飙升至两亿。',
    content: `<p>某知名导演筹备三年的新片上映首周票房仅收获三千万，与两亿的制作成本形成鲜明对比，堪称年度最大票房惨案。</p>
<p>据剧组人员向本社爆料，影片拍摄期间该导演反复修改剧本，最离谱的一次是在杀青前三天要求重拍一半的戏份。</p>
<p>"他永远不满意，永远要改。每次改了又觉得之前的版本更好，然后又改回去。投资人的钱在他眼里跟纸一样。"一位剧组核心成员无奈地表示。</p>
<p>由于导演的反复修改，影片制作周期从计划的四个月延长到了十个月，制作成本也从最初的八千万飙升至两亿。</p>
<h2>投资方血本无归</h2>
<p>按照目前票房走势，投资方预计亏损超过1.5亿。多家投资公司已要求对该导演的项目进行审计。</p>
<p>业内人士分析，此次惨败可能直接影响该导演下一部电影的融资能力。</p>`,
    category: 'yingshi-dongtai',
    categoryName: '影视动态',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20empty%20movie%20theater%20with%20red%20seats%20and%20a%20blank%20screen%2C%20dark%20moody%20atmosphere%2C%20dramatic%20lighting%2C%20failure%20theme%2C%20cinematic%20photography&width=800&height=450&seq=article-012&orientation=landscape',
    author: '黑料社电影组',
    publishDate: '2026-07-26',
    readCount: 87200,
    commentCount: 1420,
    tags: ['导演', '票房惨败', '改剧本', '超支', '亏损'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-013',
    title: '独家：某男团内部不和已久，成员之间已互不交流半年',
    slug: 'boy-group-internal-conflict',
    excerpt: '某当红男团的内部矛盾终于浮出水面。据团队工作人员爆料，两位核心成员因为资源分配问题产生严重矛盾，已长达半年互不交流，团队面临解散危机。',
    content: `<p>某当红男团的内部矛盾终于浮出水面。据团队工作人员向本社独家爆料，该男团内部的紧张关系已经持续了相当长时间。</p>
<p>据悉，矛盾的根源在于资源分配不均。两位核心成员因为一部热门综艺的常驻嘉宾名额产生了激烈争执，最终其中一人获得了名额，另一人因此心怀不满。</p>
<p>"他们已经半年没有私下交流过了。排练的时候各练各的，演出结束就各自离开，连聚餐都不在一起。"一位工作人员透露。</p>
<p>更令人担忧的是，两人的粉丝群体之间也爆发了激烈的骂战，甚至发展到线下互撕。</p>
<h2>经纪公司紧急公关</h2>
<p>在本社报道后，男团所属经纪公司紧急发布声明称"成员关系良好，不存在不和"，但这一声明反而被网友认为是在"此地无银三百两"。</p>
<p>有业内人士分析，该男团的合约将于明年到期，届时很可能会有成员选择单飞。</p>`,
    category: 'yinyue-quan',
    categoryName: '音乐圈',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20rehearsal%20room%20with%20two%20figures%20standing%20far%20apart%20facing%20opposite%20directions%2C%20tense%20atmosphere%2C%20dramatic%20lighting%2C%20boy%20band%20conflict%20theme%2C%20cinematic%20photography&width=800&height=450&seq=article-013&orientation=landscape',
    author: '黑料社调查组',
    publishDate: '2026-07-25',
    readCount: 156400,
    commentCount: 3420,
    tags: ['男团', '内部不和', '解散', '资源争夺', '粉丝互撕'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-014',
    title: '某网红直播间卖假货被当场揭穿，消费者集体维权索赔',
    slug: 'influencer-fake-products',
    excerpt: '某拥有两千万粉丝的网红在直播间售卖"正品大牌"化妆品，被消费者送检后证实为假货。目前已有超过两千名消费者联合维权，索赔金额超过五百万。',
    content: `<p>某拥有两千万粉丝的网红在直播间售卖"正品大牌"化妆品，被消费者送检后证实为假货。</p>
<p>事件起因是一位消费者在收到商品后觉得质地与专柜正品有明显差异，于是将产品送往专业检测机构检测。检测报告显示，该产品多项指标均不符合正品标准，确认为假货。</p>
<p>该消费者将检测报告发布到社交媒体后，迅速引发大量购买者的共鸣。有人在评论区晒出了自己使用后过敏的照片，令人触目惊心。</p>
<p>截至目前，已有超过两千名消费者联合起来，向该网红及其公司提出索赔要求，总金额超过五百万。</p>
<h2>平台紧急下架</h2>
<p>事件发酵后，该网红所在的直播平台已紧急下架其所有商品链接，并表示将配合消费者维权。</p>
<p>法律专家表示，如果假货指控成立，该网红将面临"退一赔三"的处罚，并可能承担刑事责任。</p>`,
    category: 'wanghong-bagua',
    categoryName: '网红爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Fake%20luxury%20cosmetics%20scattered%20on%20a%20dark%20table%20with%20a%20magnifying%20glass%20showing%20counterfeit%20details%2C%20investigative%20tone%2C%20moody%20atmosphere%2C%20dramatic%20lighting&width=800&height=450&seq=article-014&orientation=landscape',
    author: '黑料社编辑部',
    publishDate: '2026-07-24',
    readCount: 132800,
    commentCount: 2750,
    tags: ['网红', '假货', '直播间', '维权', '索赔'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-015',
    title: '娱乐圈真相：某颁奖典礼获奖名单提前泄露，主办方否认暗箱操作',
    slug: 'awards-show-leaked-winners',
    excerpt: '某年度音乐颁奖典礼的完整获奖名单在典礼开始前三小时被泄露到网络。名单准确率百分之百，引发公众对颁奖公正性的强烈质疑。',
    content: `<p>某年度音乐颁奖典礼的完整获奖名单在典礼开始前三小时被泄露到网络。</p>
<p>泄露的名单包含了全部十五个奖项的获奖者。令人震惊的是，当晚的颁奖结果与泄露名单完全一致，准确率达到百分之百。</p>
<p>"这说明获奖名单早在典礼前就已经确定了，所谓的现场投票、评审讨论都是演戏给观众看的。"一位业内人士直言不讳。</p>
<p>更有趣的是，名单泄露后主办方在社交媒体上发布声明称"所有奖项均为现场真实评选结果"。</p>
<h2>并非个例</h2>
<p>事实上，颁奖典礼获奖名单提前泄露并非个例。近年来多个大型颁奖典礼都曾出现类似情况。</p>
<p>有评论人士指出，目前的颁奖典礼已沦为商业利益的角力场，获奖与否更多取决于背后的资本博弈而非作品质量。</p>`,
    category: 'yulequan-neimu',
    categoryName: '娱乐圈内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20empty%20awards%20ceremony%20stage%20with%20trophies%20and%20spotlights%2C%20leaked%20document%20on%20the%20floor%2C%20moody%20atmosphere%2C%20dramatic%20shadows%2C%20scandal%20theme&width=800&height=450&seq=article-015&orientation=landscape',
    author: '黑料社编辑部',
    publishDate: '2026-07-23',
    readCount: 92100,
    commentCount: 1890,
    tags: ['颁奖典礼', '获奖名单', '泄露', '暗箱操作', '公正性'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-016',
    title: '某流量明星解约风波升级：原公司索赔一个亿',
    slug: 'idol-contract-termination-fee',
    excerpt: '某流量明星单方面宣布与原经纪公司解约后，原公司今日正式提起仲裁，要求赔偿违约金一亿元。这场解约大战或将成为娱乐圈史上最大金额的合约纠纷。',
    content: `<p>某流量明星单方面宣布与原经纪公司解约后，原公司今日正式向仲裁委员会提起仲裁，要求赔偿违约金一亿元。</p>
<p>该明星上月通过律师函单方面宣布解约，理由是公司长期拖欠分成、限制个人发展、过度安排工作等。但原公司方面全盘否认这些指控。</p>
<p>"公司在他身上投入了数以亿计的资源，培养他成为顶流。现在他红了就想甩开公司单飞，天底下哪有这样的道理？"原公司代表律师在接受采访时表示。</p>
<p>据悉，双方签署的合约中确实有一条巨额违约金条款，金额高达一亿元。</p>
<h2>粉丝发起集资应援</h2>
<p>解约消息传出后，该明星的粉丝后援会发起了"助力偶像自由"的集资活动，号召粉丝为偶像筹集解约金。</p>
<p>然而这一行为引发了广泛质疑，许多网友批评粉丝行为已经"丧失了基本理性"。</p>`,
    category: 'mingxing-heiliao',
    categoryName: '明星黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20law%20office%20with%20a%20contract%20and%20pen%20on%20the%20table%2C%20stack%20of%20money%20in%20background%2C%20dramatic%20lighting%2C%20contract%20dispute%20theme%2C%20cinematic%20photography&width=800&height=450&seq=article-016&orientation=landscape',
    author: '黑料社调查组',
    publishDate: '2026-07-22',
    readCount: 118700,
    commentCount: 2530,
    tags: ['流量明星', '解约', '违约金', '仲裁', '粉丝集资'],
    isHot: false,
    isExclusive: true,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((a) => a.isHot);
};

export const getLatestArticles = (limit: number = 10): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
};

export const getRelatedArticles = (currentId: string, category: string, limit: number = 4): Article[] => {
  return articles.filter((a) => a.category === category && a.id !== currentId).slice(0, limit);
};